var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failed"},[_c('h1',[_vm._v("Helaas")]),_c('h2',[_vm._v("Je hebt niet genoeg appels gescoord...")]),_c('button',{staticClass:"buttonAgain",on:{"click":_vm.restart}},[_c('h3',[_vm._v("Probeer opnieuw")])])])}
var staticRenderFns = []

export { render, staticRenderFns }